import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import {
  ChevronLeftArrowsIcon,
  ChevronRightArrowsIcon,
  LockerIcon,
  LockerOpenIcon,
} from '@root/shared/ui-kit'

import { SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_EXPANDED_WIDTH } from '../constants'

import { navigationExpandedAtom, navigationLockedAtom } from './atoms'
import { Navigation } from './navigation/navigation'
import { SidebarPlatformLogo } from './sidebar-platform'

export const Sidebar: React.FC = () => {
  const [expanded, setExpanded] = useAtom(navigationExpandedAtom)
  const [locked, setLocked] = useAtom(navigationLockedAtom)

  const handleExpand = () => {
    if (locked === undefined) {
      setExpanded(true)
    }
  }
  const handleShrink = () => {
    if (locked === undefined) {
      setExpanded(false)
    }
  }
  const toggleUnlockClick = () => {
    const newValue = expanded ? 'expanded' : 'collapsed'
    setLocked((value) => (value === undefined ? newValue : undefined))
  }

  return (
    <Root
      aria-expanded={expanded}
      data-pin={locked}
      onMouseLeave={handleShrink}
    >
      <ExpandTrigger onMouseEnter={handleExpand}>
        <SidebarPlatformLogo />
        <Navigation />
      </ExpandTrigger>
      <Footer onClick={toggleUnlockClick}>
        <Unlock data-pinned={locked === undefined ? undefined : true}>
          {locked ? (
            <>
              <LockerIcon size={10} />
              <ChevronLeftArrowsIcon size={12} />
            </>
          ) : (
            <>
              <LockerOpenIcon size={10} />
              <ChevronRightArrowsIcon size={12} />
            </>
          )}
        </Unlock>
      </Footer>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;

  z-index: 100;

  background: var(--background-1);
  border-right: 1px solid var(--background-3);
  width: ${SIDEBAR_COLLAPSED_WIDTH}px;

  transition: width 0.1s ease-in-out;

  position: sticky;
  top: 0;
  align-self: start;
  justify-self: start;
  min-width: 0;
  grid-column: 1;
  z-index: 250;
  height: var(--viewport-height);
  overflow: hidden;
  overflow: clip;
  pointer-events: auto;

  &[aria-expanded='true'],
  &[data-pin='expanded'] {
    width: ${SIDEBAR_EXPANDED_WIDTH}px;
  }

  container: sidebar / size;
`

const ExpandTrigger = styled.div`
  grid-row: 1 / 3;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  min-height: 0;
  overflow: hidden;
`

const Footer = styled.div`
  display: grid;
  padding: 5px;
`

const Unlock = styled.div`
  background: var(--appearanceA-2);
  color: var(--text-11);

  border-radius: 6px;
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: space-between;

  padding-block: 4px;
  padding-inline: 7px;
  border-radius: 6px;
  gap: 3px;
  width: 100%;
  height: 18px;
  cursor: pointer;

  transition: all 0.1s ease-in-out;

  &:hover {
    background: var(--appearanceA-4);
  }
  &[data-pinned] {
    color: var(--primary-9);
  }
`
